import Vue from 'vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

// eslint-disable-next-line vue/component-definition-name-casing
Vue.component('vue-dropzone', vue2Dropzone)
